import type { IControlSelectBase } from './SelectBase';

import { Box, InlineStack, Icon, Text } from '@shopify/polaris';
import { Actions } from './Actions';

interface SelectBaseContentProps extends IControlSelectBase {
  isHovered?: boolean;
  onDelete?: () => void;
}

export const SelectBaseContent: React.FC<SelectBaseContentProps> = ({
  label,
  icon,
  children,
  textVariant = 'bodyMd',
  disabled = false,
  draggable,
  dependentControls,
  uid,
  info,
  id,
  labelAlign,
  isHovered,
  onDelete,
}) => {
  const isGenerallyDragging = draggable?.isDragging;
  const isSelfDragging = draggable?.snapshot.isDragging;
  const isHoveredAndNotDragging = isHovered && !isGenerallyDragging;
  const shouldShowActions = isHoveredAndNotDragging || isSelfDragging;

  const opacity = disabled ? '0.5' : '1';
  const borderBlockEndWidth = isSelfDragging ? '025' : '0';
  const paddingBlockEnd = children ? '150' : '0';
  const alignment = labelAlign ?? 'start';

  return (
    <Box
      borderColor="border"
      borderBlockStartWidth="025"
      paddingInline="200"
      paddingBlock="150"
      opacity={opacity}
      borderBlockEndWidth={borderBlockEndWidth}
    >
      <InlineStack align="space-between" wrap={false}>
        <Box minWidth="0" paddingBlockEnd={paddingBlockEnd} width="100%">
          <InlineStack align={alignment} wrap={false}>
            <Text variant={textVariant} as="p" truncate>
              {label}
            </Text>
            {icon && (
              <Box>
                <Icon source={icon} />
              </Box>
            )}
          </InlineStack>
        </Box>

        {shouldShowActions && (
          <Actions
            draggable={draggable}
            dependentControls={dependentControls}
            uid={uid || id}
            info={info}
            onDelete={onDelete}
          />
        )}
      </InlineStack>

      {children}
    </Box>
  );
};
